import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'login-brand-panel',
  templateUrl: './brand-panel.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'hidden h-full min-h-0 lg:block lg:w-1/2' },
})
export class LoginBrandPanel {
  readonly pillars = [
    'AI-generated briefs in seconds',
    'Instant creator matching',
    '100% brand-safe moderation',
    'Live attribution & sentiment',
  ];
}
